import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';
import { newTrade, deleteTrade } from '../../store/actions/tradeBookActions';
import { firestoreConnect } from 'react-redux-firebase';
import NavigationBar from '../layout/NavigationBar';
import { notify } from 'react-notify-toast';
import { Container } from 'reactstrap';

import '../../css/TradingBook.css';
import '../../css/animate.css';

import Company from './components/Company';

class TradingBook extends Component {
    state = {
        shares: 0,
        sharesCalculated: false,
        selected: 'Facebook',
    };

    formatNumber = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    newTrade = (information, type) => {
        const company = information.company;
        const counterparty = information.name;
        const amount = information.amount;
        const price = information.price;

        this.props.newTrade({
            uid: this.props.auth.uid,
            type,
            company,
            counterparty,
            amount,
            price,
        });

        notify.show('Trade has been successfully uploaded.', 'success');
    };

    removeTrade = (information) => {
        const trade = {
            amount: information.amount,
            company: information.company,
            counterparty: information.name,
            price: information.price,
            type: information.type,
            uid: this.props.auth.uid,
        };

        // let decrement = (information.type === 'buy') ? Math.abs(parseInt(information.amount)) * -1 : 0;

        this.props.deleteTrade(trade);
    };

    formatTrades = (trades) => {
        if (trades && trades[0]) {
            let template = {
                companies: {
                    buy: {},
                    sell: {},
                },
            };

            const entries = trades[0]

            for (const key in entries) {
                const trade = entries[key];

                const record = {
                    name: trade.counterparty,
                    amount: trade.amount,
                    price: trade.price,
                };

                if(trade.type === 'buy') {
                    if (template.companies.buy[trade.company]) {
                        template.companies.buy[trade.company].push(record);
                    } else {
                        template.companies.buy[trade.company] = [record];
                    }
                } else {
                    if (template.companies.sell[trade.company]) {
                        template.companies.sell[trade.company].push(record);
                    } else {
                        template.companies.sell[trade.company] = [record];
                    }
                } 
            }

            return template.companies;
        }
    };

    totalShares = (buy, sell) => {
        let totalShares = 0;

        for (const company in buy) {
            const stock = buy[company];
            for (const item in stock) {
                const data = stock[item];
                totalShares += parseFloat(data.amount);
            }
        }

        for (const company in sell) {
            const stock = sell[company];
            for (const item in stock) {
                const data = stock[item];
                totalShares -= parseFloat(data.amount);
            }
        }

        return totalShares;
    };

    render() {
        const { auth } = this.props;

        if (!auth.uid) return <Redirect to="/welcome" />;

        let companies = this.formatTrades(this.props.companies);

        // TODO
        const names = ['Apple', 'Facebook', 'Microsoft', 'SpaceX', 'Tesla', 'Twitter'];

        const choices = [];

        for (const key in names) {
            choices.push(
            <div key={key} className={(this.state.selected === names[key]) ? 'companyChoice selectedCompany' : 'companyChoice'} onClick={(e) => this.setState({ selected:names[key] }) } >
                <span>{ names[key] }</span>
            </div>)
        }

        return (
            <div className={ 'darkTradebook' }>
                <NavigationBar activeTab="trading-book" />
                <Container id="page-wrap" fluid="xl" style={{ maxWidth:1400 }}>
                    <div className="action">
                        <div className="title">
                            <h2>Trading Book</h2>
                        </div>
                    </div>
                    <div className="switcher">
                        { choices }
                    </div>
                    <div className="trades">
                        <Company
                            name={this.state.selected}
                            price="5.65"
                            newTrade={this.newTrade}
                            removeTrade={this.removeTrade}
                            companies={companies}
                        />
                    </div>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        companies: state.firestore.ordered.tradebook,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        newTrade: (information) => dispatch(newTrade(information)),
        deleteTrade: (information) => dispatch(deleteTrade(information)),
    };
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect((props) => [
        {
            collection: 'trading-book',
            doc: props.auth.uid,
            storeAs: 'tradebook',
        },
    ]),
)(TradingBook);
